<template>
	<div class="center">
		<form method="post" id="form" enctype="multipart/form-data" action="/">
			<div class="content_wrap">
				<div class="content">
					<div class="tit">
						<i class="go_back" @click="GoBack()"></i><span>制作内容</span>
					</div>
					<div class="from_box">
						<!-- 标题 start -->
						<div class="inf_wrap clearfix">
							<div class="from_tit">
								<label for="ipt_tit">标题</label>
							</div>
							<div class="from_ipt regIpt">
								<input type="text" v-model="contentModel.bg_title" id="ipt_tit" placeholder="例：一、整一整（可选填）">
							</div>
							<!-- <div class="clearfix"></div> -->
						</div>
						<!-- 标题 end -->
						<!-- 音乐 start -->
						<div class="inf_wrap clearfix">
							<div class="from_tit">
								<label for="ipt_tit">音乐</label>
							</div>
							<div class="from_ipt from_text">
								<div class="file-box" @click="addUploadFile(0,1,2)">+添加音乐</div>
							</div>
							<!-- <div class="clearfix"></div> -->
						</div>
						<div class="inf_wrap clearfix" v-if="contentModel.music.length >0">
							<div class="from_tit">
								<label for="ipt_tit">&nbsp;</label>
							</div>
							<div style="    margin-left: 282px;">
								<div v-for="(music, index) in contentModel.music" class="upload-list-li " style="border: 0;">
									<a class="upload-list-li-name">
										<label class="upload-list-li-label" @click="delMusic(index,contentModel.music)"><i
												class="fa fa-trash-o"></i></label>
										<span>{{music.name}}</span>
										<div class="music_play_icon music_play_icon_7" @click="playMusic(music)" ></div>
									</a>
								</div>
							</div>
						</div>
						<!-- 音乐 end -->

						<!-- 文本、诗歌、视频、图片 start -->

						<!-- 文本 start -->
						<div class="inf_wrap wb_txt clearfix">
							<div class="from_tit">
								<label for="ipt_tit">文本</label>
							</div>
							<div class="from_ipt area_text">
								<editor v-model="contentModel.bg_text" form="content" :isClear="false" @change="(val) => setContentText(val,contentModel)" :issue_id="templateInfo.package_id" ></editor>

							</div>
							<!-- <div class="clearfix"></div> -->
						</div>
						<!-- 文本 end -->

						<!-- 是否有教学详解 start -->
						<div class="inf_wrap clearfix">
							<div class="from_tit">
								<label for="ipt_tit">是否有教学详解</label>
							</div>
							<div class="from_switch">
								<el-switch v-model="explainShow" @change="openExplain"></el-switch>
							</div>
							<!-- <div class="clearfix"></div> -->
						</div>

					</div>
					<!-- 备课详情 start -->
					<div class="pre_lesson" v-if="explainShow">
						<div class="bkxq_tit">
							<div class="tits">教学详解</div>
						</div>
						<div class="lesson_wrap" v-for="(item,ekey) in explainModel" :key="ekey">
							<div class="lesson_tit">
								<div class="new_add">
									<span @click="delExplain(ekey)"><i class="el-icon-remove-outline"></i>删除</span>
								</div>
							</div>
							<div class="lesson_inf">
								<!-- 备课标题 start -->
								<div class="inf_wrap clearfix">
									<div class="from_tit">
										<label for="ipt_tit">标题</label>
									</div>
									<div class="from_ipt bk_ipt">
										<input type="text" id="ipt_tit" class="ipt_tit" placeholder="例：一、整一整（可选填）"
											v-model="item.title">
										<div class="tishi">
											<span class="per_err"><i class="el-icon-warning"></i>标题不可为空</span>
											<span class="per_suc"><i class="el-icon-success"></i></span>
											<span class="per_warn"><i class="el-icon-info">不可超过30个汉字</i></span>
										</div>
									</div>
									<!-- <div class="clearfix"></div> -->
								</div>
								<!-- 备课标题 end -->

								<!-- 备课音乐 start-->

								<div class="inf_wrap clearfix">
									<div class="from_tit">
										<label for="ipt_tit">音乐</label>
									</div>
									<div class="from_ipt from_text">
										<div class="file-box" @click="addUploadFile(ekey,2,2)">+添加音乐</div>
									</div>
									<!-- <div class="clearfix"></div> -->
								</div>
								<div class="inf_wrap clearfix" v-if="item.music.length >0">
									<div class="from_tit">
										<label for="ipt_tit">&nbsp;</label>
									</div>
									<div style="    margin-left: 282px;">
										<div v-for="(music, index) in item.music" class="upload-list-li "
											style="border: 0;">
											<a class="upload-list-li-name">
												<label class="upload-list-li-label" @click="delMusic(index,item.music)"><i
														class="fa fa-trash-o"></i></label>
												<span>{{music.name}}</span>
												<div class="music_play_icon" @click="playMusic(music)" ></div>
											</a>
										</div>
									</div>
								</div>

								<!-- 备课音乐  end -->

								<!-- 备课文本 start -->
								<div class="inf_wrap wb_txt clearfix">
									<div class="from_tit">
										<label for="ipt_tit">文本</label>
									</div>
									<div class="from_ipt area_text area_text1">
										<editor v-model="item.bg_text" form="content" :isClear="false" @change="(val) => setContentText(val,item)" :issue_id="templateInfo.package_id" ></editor>
							
									</div>
									<!-- <div class="clearfix"></div> -->
								</div>
								<!-- 备课文本 end -->
							</div>
						</div>
						<div class="inf_wrap from-wrap-newadd clearfix" style="margin-top:15px;">
							<div class="from_tit addnew_wrap">
								<label for="ipt_tit"></label>
							</div>
							<div class="newadd from_ipt">
								<el-button plain @click="addExplain()" class="newitem"> + 新增</el-button>
							</div>
							<!-- <div class="clearfix"></div> -->
						</div>
					</div>
					<!-- 备课详情 end -->
				</div>
			</div>
		</form>
		<div class="preservaation">
			<div class="preservaation-li">
				<span @click="saveAll" class="btn">保存</span>
				<span @click="GoBack()" class="btn brn-back">返回</span>
				<span class="btn  brn-back" @click="open_preview(1)">预览(手机端)</span>
			</div>
		</div>
		<!-- yinyue -->
		<div class="video_wrap" style="position: fixed;z-index: -1;" v-if="alert_big_preview_moblie" >
			<div class="video_b fl_left" @click="player" v-model="psop"></div>
			<div class="video_con fl_left">
				<div class="miuse_top">
					<div class="mus_TB">
						<div class="mus_tit fl_left">音乐名称</div>
						<div class="mus_time fl_right">
							<span class="starttime">00:00</span> /
							<span class="endtime">00:00</span>
						</div>
						<div class="audis_wrap">
							<audio :src="musicPlay" class="audis" id="audis"></audio>
						</div>
						<div class="fixclear"></div>
					</div>
					<div class="mus_bar">
						<b class="progress-bar" :style="{width:proBar+'%'}"></b>
					</div>
				</div>
			</div>
		</div>
		<!-- 手机预览 -->
		<div class="alertBox_big" v-if="alert_big_preview_moblie" v-drag>
			<div class="alert_context">
				<div class="vue-oss-uploader-video-top vue-oss-uploader-video-top-left clearfix">
					<div class="fl_left">预览</div>
					<div class="fl_right">
						<button class="photoviewer-button photoviewer-button-close" title="close"
							@click="close_preview()">
							<svg viewBox="0 0 24 24" class="svg-inline-icon">
								<path fill="currentColor" d="M13.46,12L19,17.54V19H17.54L12,13.46
				            	L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46
				            	L13.46,12Z"></path>
							</svg>
						</button>
					</div>
				</div>
				<div class="mobile-width-3 ">
					<div class="rel" style="height:100%">
						<div class="abs mold_left template_8"
							:class="{template_7 : template_id == 3,template_8 : template_id == 4}">
							<div class="abs mold_left_title">
								<div class="mold_title" @click="get_right_content(item.id,key)"
									v-for="(item,key) in template_info"
									:class="{template_7_active:item.id == module_ids && item.template_id == 3,template_8_active :item.id == module_ids && item.template_id == 4}">
									<div class="icon_img_src fl_left">
										<img :src="item.id == module_ids?item.img.src1:item.img.src" alt="">
									</div>
									<span class="changeFont fl_left" v-if="item.name.length > 6"
										style="font-size:12px;"
										:class="{template_7_active :item.id == module_ids && item.template_id == 3,template_8_active :item.id == module_ids && item.template_id == 4}">{{item.name}}</span>
									<span style="" class="changeFont fl_left" v-else
										:class="{ template_7_active :item.id == module_ids &&item.template_id == 3,template_8_active :item.id == module_ids && lessonInfo.template_id == 4 }">{{item.name}}</span>
									&nbsp;<span v-if="item.minute != 0 " style="height:41px;" class="fl_left"
										:class="{ template_7_active :item.id == module_ids &&item.template_id == 3,template_8_active :item.id == module_ids && item.template_id == 4}">{{item.minute}}'</span>
								</div>
							</div>
							<div class="total_minute abs"
								:class="{template_7 : template_id == 3, template_8: template_id == 4 }">
								<div>该节课共{{totalMinute}}'</div>
							</div>
						</div>
						<div class="mobile_right_content">
							<div class="startBox change_scroll">
								<div class="maojiorBox">
									<div class="miuse_wrap" v-if="template_id == 4">
										<div class="miuse_tit fl_left dan_btn" @click="play($event,index)"
											:class="{'dbtn0':index==0,'dbtn1':index==1,'dbtn2':index==2,'dbtn3':index==3,'dbtn4':index==4,'dbtn5':index==5,'dbtn6':index==6,'dbtn7':index==7,'dbtn8':index==8,'dbtn9':index==9}"
											v-for="(item,index) in template_info[numCl].music">
											<span>{{item.oldname}}</span>
											<em>{{item.src}}</em>
										</div>
									</div>
									<div class="xunListB" v-for="(item,index) in inforShow">
										<div v-if="recipient != item.id">
											<div class="clearfix momoTop">
												<div class="fl_left mode_one_title">{{item.json_data.bg_title}}</div>
												
												<div class="bkxq_wrapper fl_right"
													@click="xq_show(index,1)" v-if="item.have_explain == 1">教学详解</div>
												<div class="xq_box abs">
													<div class="teplate_tit change_scroll">
														<div class="xq_del" @click="xq_hide()">
														</div>
														<div class="xq_list" v-for="(val,index) in inforShow1">
															<div class="clearfix" style="padding: 12px 0;">
																<div class="fl_left mode_one_title">{{val.title}}</div>
																<div class="music_icon fl_left">
																	<div class="fl_left music" v-if="val.music"
																		v-for="(item_music,key_music) in val.music"
																		:class="{zcir:item_music.src == play_music, music_play_icon_7 : template_id == 3 ,  music_play_icon_8 : template_id == 4}">
																	</div>
																</div>
																<!-- <div class="xqTit fl_left">{{val.title}}</div> -->
															</div>
															<div class="xqCon">
																<div v-html="val.bg_text">{{val.bg_text}}</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="tn_con"
												:class="item.template == 3 ? 'class_strong1' : 'class_strong2' "
												v-html="item.json_data.bg_text">{{item.json_data.bg_text}}</div>
										</div>
										<div v-else>
											<div class="clearfix momoTop">
												<div class="fl_left mode_one_title">{{textvalue}}</div>
												<div class="bkxq_wrapper fl_right"
													@click="xq_show(index,2)" v-if="item.have_explain == 1">教学详解3</div>
												<div class="xq_box abs">
													<div class="teplate_tit change_scroll">
														<div class="xq_del" @click="xq_hide()">
														</div>
														<div class="xq_list" v-for="(val,index) in bk_con">
															<div class="clearfix" style="padding: 12px 0;">
																<div class="fl_left mode_one_title">{{val.title}}</div>
																<div class="music_icon fl_left">
																	<div class="fl_left music" v-if="val.music"
																		v-for="(item_music,key_music) in val.music"
																		:class="{zcir:item_music.src == play_music, music_play_icon_7 : template_id == 3 ,  music_play_icon_8 : template_id == 4}">
																	</div>
																</div>
															</div>
															<div class="xqCon">
																<div v-if="val.bg_text" v-html="val.bg_text">
																	{{val.bg_text}}</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="tn_con"
												:class="item.template == 3 ? 'class_strong1' : 'class_strong2' "
												v-html="text">{{text}}</div>
										</div>
									</div>
									<div class="xunListB" v-if="add_show && module_ids == module_id">
										<div class="clearfix momoTop">
											<div class="fl_left mode_one_title">{{textvalue}}</div>
											<div class="bkxq_wrapper fl_right"
												@click="xq_show(inforShow.length ,2)" v-if="explainShow">教学详解</div>
											<div class="xq_box abs">
												<div class="teplate_tit change_scroll">
													<div class="xq_del" @click="xq_hide()"
														:style="{backgroundImage: template_id == 3 ? 'url(/static/imgs/close_zky.png)' : 'url(/static/imgs/copy_close_zky.png)'}">
													</div>
													<div class="xq_list" v-for="(val,index) in bk_con">
														<div class="clearfix" style="padding: 12px 0;">
															<div class="fl_left mode_one_title">5{{val.title}}</div>
															<div class="music_icon fl_left">
																<div class="fl_left music" v-if="val.music"
																	v-for="(item_music,key_music) in val.music"
																	:class="{zcir:item_music.src == play_music, music_play_icon_7 : template_id == 3 ,  music_play_icon_8 : template_id == 4}">
																</div>
															</div>
														</div>
														<div class="xqCon">
															<div v-if="val.content" v-html="val.content"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="tn_con"
											:class="template_id == 3 ? 'class_strong1' : 'class_strong2' "
											v-html="text">{{text}}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		
		<!-- 上传文件 start -->
		<upload 
		:upload_type="upload_type" 
		:upload_show="upload_show"
		:issue_id="templateInfo.package_id"
		v-if="upload_show"
		@closeUpload="closeUpload"
		@checkFile="checkFile">
		</upload>
		<!-- 上传文件 end -->
		
		<!-- 查看音乐 -->
		<el-dialog :visible.sync="musicShow" v-if="musicShow" :title="musicName" width="460px" :modal="false" draggable>
			<audio ref="audio" :src="musicSrc" controls="controls" style="width:420px" autoplay></audio>
		</el-dialog>
	</div>
</template>
<script>
	import Upload from '@/components/media/upload'
	import Editor from '@/components/media/editor'
	export default {
		components: {
			Upload,
			Editor
		},
		computed: {
			totalMinute() {
				var total = 0;
				let _this = this;
				for (var i = 0; i < _this.template_info.length; i++) {
					total += parseInt(_this.template_info[i].minute)
				}
				return total
			},
		},
		name: 'imageView',
		data() {
			return {
				numCl:0,
				psop:0,
				proBar:'',
				musicPlay:'',
				i_switch: true,
				add_show: false,
				alert_big_preview_moblie: false,
				alert_small_preview: true,
				key: '',      //tw下标
				index: '',    //one/two
				show: false,   //loading状态
				title: '视频',   //上传弹窗显示title
				token: '',   //分片上传token
				files: [],    //存储视频、图片、音频
				template_id: '',   //模版id
				inforShow: [],
				module_ids: "",
				inforShow1: [],
				template_info: [],
				proBar: 0,     //进度条
				shows: false,
				recipient: 0,


				UPloads: false,
				UPloadz: false,
				bd_img: '',
				bdvideoSrc: '',
				bd_video: '',
				module_id: "",    //左侧栏目id
				fileList: [],
				textvalue: '',
				text: '',
				bk_con: [{ type: 0, title: '', bg_text: '', music: [], color: "#000000" }],
				Jhimg: [],
				num: 0,
				// time:'',
				currentAjax: null,
				xianshiA: false,
				course: '',
				play_pause: false,
				music: "",
				play_music: "",
				audio: "",
				tiemr: null,
				type: "",
				color: "#000000",
				oldKey:'',
				
				loading: false,  //loading状态

				upload_type:0,//上传类型
				upload_show: false,//上传弹窗

				templateInfo: [], //模板信息
				lessonInfo: [], //课程包信息
				formInfo:'', //每个小节信息，包括内容ID

				position:1, //位置，1——表示主内容 2——教学详解

				contentModel:{ //内容模型model
					bg_title:'',
					bg_text:'',
					music:[],
				},

				musicShow:false,//音乐播放
				musicSrc:'', //当前播放音乐
				musicName:'',//当前播放音乐名称

				explainShow:false, //展示教学详解
				explainModel:[], //教学详解模型model,
				explainKey:'', //当前教学详解KEY


				detailId:'', //主内容ID
				detailData:'', //主内容数据
				explaindata:'',//教学法数据
			}
		},
		mounted() {
			history.pushState(null, null, document.URL);
			if (window.history && window.history.pushState) {
				history.pushState(null, null, document.URL);
				window.addEventListener('popstate', this.GoBack, false);
			}
		},
		methods: {
			//上传
			addUploadFile(ekey,position,type) {
				let _this = this;
				_this.position = position;
				_this.upload_show = true
				_this.upload_type = type
				_this.explainKey 	= ekey
			},
			//关闭上传框
			closeUpload(){
				let _this = this;
				_this.upload_show = false;
			},
			
			//播放音乐
			playMusic(music){
				let _this = this; 
				_this.musicSrc = music.src;
				_this.musicName = music.name;
				_this.musicShow = true;
			},
			//删除音乐
			delMusic(index, item) {
				item.splice(index, 1);
			},
			//选择文件
			checkFile(file){
				let _this 		= this;
				let _html = { "src": file.url, "url": '../../media/' + file.name, 'name': file.title };
				if (_this.position == 1) {
					_this.contentModel.music.push(_html);
				} else if (_this.position == 2) {
					_this.explainModel[_this.explainKey].music.push(_html);
				}
			},

			//设置文本
			setContentText(html,item){
				let _this = this;
				_this.$set(item,"bg_text",html);
			},
			
			//打开教学详解
			openExplain(val) {
				let _this = this;
				_this.explainModel = [];
				if (val) {
					_this.addExplain();
				}
			},
			//新增教学详解
			addExplain() {
				let _this = this;
				_this.explainModel.push({
					title: '',
					bg_text: '',
					music: [],
				})
			},
			//删除教学详解
			delExplain(i) {
				var _this = this;
				_this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					type: 'warning'
				}).then(() => {
					_this.$message.success("删除成功");
					_this.explainModel.splice(i, 1);
					if (_this.explainModel.length == 0){
						_this.explainShow = false;
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			//加载动画
			getLoading(){
				let _this = this;
				_this.loading = _this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
			},
			
			//保存
			saveAll() {
				let _this = this;
				_this.saveDetail();
			},
			
			//保存主内容
			saveDetail(){
				let _this = this;
				let _url 	= '' , _data 	= {};
				if(_this.contentModel.bg_title == "" && _this.contentModel.bg_text == ""){
					_this.$notify({
						title: '警告',
						message: '请添加标题或内容',
						type: 'warning'
					});
					return false;
				}
				if(_this.formInfo != null){
					_url 	= 'editdetail'; 
					_data 	= {
						detail_id: _this.formInfo.conId,
						json_data: JSON.stringify(_this.contentModel) ,
						have_explain: _this.explainShow ? 1 : 0,
					};
				}else{
					_url 	= 'adddetail'; 
					_data 	= {
						column_id: _this.templateInfo.module_id,
						json_data: JSON.stringify(_this.contentModel) ,
						have_explain: _this.explainShow ? 1 : 0,
					};
				}
				_this.getLoading();
				_this.$axios.post(_url, _data)
				.then(({ data: { data } }) => {
					_this.$Message.success('保存成功');
					_this.loading.close();
					if(_this.formInfo == null){
						_this.detailId = data;
					}
					_this.saveExplain();
				})
			},
			//保存教学详解
			saveExplain(){
				let _this = this;
				if(!_this.explainShow){
					_this.saveBack();
					return false;
				}
				//编辑or添加
				let _url 	= '' , _data 	= {};
				if(_this.explaindata){
					_url 	= 'editexplain';
					_data 	= {
						explain_id: _this.explaindata.id,
						json_data: JSON.stringify(_this.explainModel)
					};
				}else{
					_url 	= 'addexplain';
					_data 	= {
						detail_id: _this.detailId,
						json_data: JSON.stringify(_this.explainModel)
					};
				}
				_this.getLoading();
				_this.$axios.post(_url, _data).then((res) => {
					_this.loading.close();
					if (res.data.code == 200) {
						_this.saveBack();
					} else {
						_this.$Message.error(res.data.message)
					}
				});
			},
			play(e, key) {
				const _this = this;
				e.stopPropagation()
				if (typeof ($(document).find('video')[0]) == 'object') {
					$(document).find('video')[0].pause()
				}
				$('div.miuse_tit.fl_left.dan_btn').eq(key).addClass('danclick').siblings().removeClass('danclick')
				this.musicPlay = _this.template_info[_this.numCl].music[key].src
				$('.mus_tit').html($('.miuse_tit').eq(key).find('span').html())
				var time = document.getElementById("audis");
				time.oncanplay = function () {
					var minute = parseInt(time.duration / 60);
					var second = Math.round(time.duration % 60);
					if (minute < 10) {
						minute = "0" + minute;
					}
					if (second < 10) {
						second = "0" + second;
					}
					$('.mus_time').find('.endtime').html(minute + ":" + second);
				}
				this.proBar = 0;
				
				if(_this.oldKey===''){
					_this.psop = 0;
					_this.oldKey=key;
				}
				else{
					if(_this.oldKey!=key){
						_this.psop = 0;
						_this.oldKey=key;
					}
					else{
						// _this.psop = 0;
						_this.oldKey=key;
					}
				}
				// 
				_this.$nextTick(() => {
					_this.player()

				})
			},
			player() {
				if (typeof ($(document).find('video')[0]) == 'object') {
					$(document).find('video')[0].pause()
				}
				var time = document.querySelectorAll(".audis_wrap audio");
				var starttime = document.querySelector('.starttime');
				if (this.psop) {
					$('.audis').get(0).pause();
					this.psop = 0;
					$('.video_b').removeClass('pause');
				} else {
					$('.audis').get(0).play();
					$('.video_b').addClass('pause');
					this.psop = 1;
					$('.audis').on('timeupdate', function () {
						for (var i = 0; i < time.length; i++) {
							var minutes = parseInt(time[i].currentTime / 60);
							var seconds = Math.round(time[i].currentTime % 60);
							if (minutes < 10) {
								minutes = "0" + minutes;
							}
							if (seconds < 10) {
								seconds = "0" + seconds;
							}
							$('.starttime').text(minutes + ":" + seconds);
							this.proBar = $('.progress-bar').width((time[i].currentTime / time[i].duration) * 100 + '%')
							if (this.proBar == 100) {
								$('.audis').get(0).pause();
								$('.video_b').removeClass('pause');
								this.proBar = 0
							}
						}
					});
				}
			},
			//显示教学详解
			xq_show(key, index) {
				let _this = this;
				// console.log(index)
				if (index == 1) {
					_this.$axios.post('getexplainlist', { detail_id: _this.inforShow[key].id }).then(res => {
						if (res.data.code == 200) {
							console.log(res.data.data.json_data);
							for (var i = 0; i < res.data.data.json_data.length; i++) {
								res.data.data.json_data[i].content = res.data.data.json_data[i].bg_text;
							}
							_this.inforShow1 = res.data.data.json_data
							$('.xunListB').eq(key).find('.xq_box').show();
						}
						else {
							_this.$message.error(res.data.message)
						}
					}).catch(error => {
						console.log(error)
					})
				}
				else {
					// console.log(key)
					$('.xunListB').eq(key).find('.xq_box').show();
				}

			},
			//关闭教学详解
			xq_hide() {
				$('.xq_box').hide()
			},
			close_preview() {
				this.alert_big_preview_moblie = false
				this.alert_small_preview = true
			},
			open_preview(index) {
				let _this = this;
				if (index == 1) {
					_this.alert_big_preview_moblie = true
					_this.alert_small_preview = false
					_this.module_ids = _this.module_id
				}
				else if (index == 2) {
					_this.alert_big_preview_moblie = false
					_this.alert_small_preview = false
					_this.module_ids = _this.module_id
				}
				else {
					_this.alert_big_preview_moblie = false
					_this.alert_small_preview = true
				}
			},

			//返回上一层
			saveBack(){
				const _this = this;
				_this.$router.replace({ path: '/addCategory/makTep', name: 'makTep', query: { id: this.$route.query.id, table_id: this.$route.query.table_id, package: this.$route.query.package, courseId: this.$route.query.courseid, pocId: this.$route.query.pocId } });
			},
			//返回上一层
			GoBack() {
				const _this = this;
				if (_this.textvalue == '' && _this.text == '' && _this.fileList.length == 0) {
					this.$router.replace({ path: '/addCategory/makTep', name: 'makTep', query: { id: this.$route.query.id, table_id: this.$route.query.table_id, package: this.$route.query.package, courseId: this.$route.query.courseid, pocId: this.$route.query.pocId } });
				} else {
					this.$confirm('此操作将不保存编辑的内容, 是否继续?', '提示', {
						onfirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.replace({ path: '/addCategory/makTep', name: 'makTep', query: { id: this.$route.query.id, table_id: this.$route.query.table_id, package: this.$route.query.package, courseId: this.$route.query.courseid, pocId: this.$route.query.pocId } });
					})
				}
			},
			
			get_right_content(item,index) {
				let _this = this;
				_this.numCl=index;
				$('.xq_box').hide()
				_this.module_ids = item
				_this.$axios.post('getdetaillist', { column_id: item }).then(res => {
					if (res.data.code == 200) {
						_this.inforShow = res.data.data
					}
					else {
						_this.$message.error(res.data.message)
					}
				}).catch(error => {
					console.log(error)
				})
			},

			get_mold_list() {
				let _this = this;
				_this.$axios.post('getcolumnlist', { table_id: _this.lessonInfo.table_id }).then(res => {
					if (res.data.code == 200) {
						_this.template_info = res.data.data;
						
					}
					else {
						_this.$message.error(res.data.message)
					}
				}).catch((err) => {
					console.log(err)
				})
			},
			//获取主内容
			getDetail(){
				let _this = this;
				_this.$axios.post('getdetailmsg', {
					detail_id: _this.formInfo.conId
				}).then(res => {
					if (res.data.code == 200) {
						_this.detailData 	= res.data.data;
						_this.contentModel 	= res.data.data.json_data;
						_this.explainShow = _this.detailData.have_explain == 1 ? true : false;

						//获取教学详解
						if (_this.explainShow) {
							_this.getExplain();
						}
					}
					else {
						_this.$message.error(res.data.message)
					}
				}).catch(error => {
					console.log(error)
				})
			},
			//获取教学详解
			getExplain(){
				let _this = this;
				_this.$axios.post('getexplainlist', { 
					detail_id: _this.formInfo.conId
				}).then(res => {
					if (res.data.code == 200) {
						_this.explaindata 	= res.data.data;
						_this.explainModel 	= res.data.data.json_data;
					}
					else {
						_this.$message.error(res.data.message);
					}
				}).catch(error => {
					console.log(error)
				})
			},
			//初始化数据
			init(){
				let _this = this;
				//编辑状态
				if (_this.formInfo != null) {
					_this.detailId 	= _this.formInfo.conId;
					_this.getDetail()
				}
			},
		},
		beforeDestroy() {
			var _this = this;
			_this.play_pause = true
			_this.music = ""
			if (_this.audio != "") {
				_this.audio.pause();
			}
			clearInterval(_this.tiemr);
		},
		created() {
			const _this = this;
			_this.lessonInfo 	= JSON.parse(sessionStorage.getItem('lesson'));
			_this.templateInfo 	= JSON.parse(localStorage.getItem('template'));
			_this.formInfo	 	= JSON.parse(sessionStorage.getItem('formID'));
			_this.module_id = _this.templateInfo.module_id;
			_this.template_id = _this.templateInfo.tamplate_id;
			_this.get_mold_list()
			_this.get_right_content(_this.module_id,0)
			_this.init();
		},
		destroyed() {
			window.removeEventListener('popstate', this.GoBack, false);
		},
	};
</script>
<style scoped>
.content_wrap{margin:0 auto}
.go_back{width:27px;height:27px;display:inline-block;vertical-align:middle;background:url(/static/imgs/back_purple.png) 0 center no-repeat;background-size:100%;margin-right:12px;cursor:pointer}
.content{width:100%;box-sizing:border-box;background:#fff;margin-top:20px;padding-bottom:30px;margin-bottom:64px}
.tit{padding-left:30px;font-size:14px;color:#333;height:64px;line-height:64px;box-sizing:border-box;border-bottom:1px solid #f5f5f5}
.inf_wrap{margin-top:30px}
.from_tit{width:262px;text-align:right;margin-right:19px;font-size:14px;line-height:40px;float:left}
.from_ipt{width:640px;float:left;border:1px solid #ddd;border-radius:4px}
.from_ipt #ipt_tit{width:100%;height:40px;font-size:14px;border:0;box-sizing:border-box;padding-left:24px;background:#f5f5f5;border-radius:4px}
.from_text{width:106px;height:40px;background:#f5f5f5;font-size:14px;color:#999;line-height:40px;text-align:center;cursor:pointer;position:relative}
.bk_ipt,.per_tet,.regIpt{position:relative}
.tishi{position:absolute;top:0;right:-130px;width:130px;height:40px;line-height:40px;text-align:center}
.per_err{color:#dc143c;position:absolute;top:0;right:0;display:none}
.per_suc{color:#00ff7f;position:absolute;top:0;right:-20px;text-align:left;width:100%;height:100%;display:none}
.per_warn{color:#dc143c;position:absolute;top:0;right:-10px;text-align:left;width:100%;height:100%;display:none}
.per_txt{width:650px;height:40px;line-height:40px;font-size:14px;padding-left:24px;box-sizing:border-box;background:#f5f5f5;border:1px solid #ddd;border-radius:4px}
.selct_con{width:640px;height:40px;position:relative;border:none}
.abled,.abled1,.from_ipt .dis_ab,.from_ipt .dis_abl{width:60px;height:40px;border:none;outline:0;line-height:40px;padding-left:18px;background:#f5f5f5}
.icons{position:absolute;top:0;right:0;color:#999;height:100%;width:60px;line-height:34px;text-align:center}
.list_slts{box-sizing:border-box;display:none;position:absolute;z-index:99999}
.list_slts li{width:320px;height:40px;line-height:40px;box-sizing:border-box;padding-left:20px;background:#f5f5f5;border:1px solid #ddd;border-top:0}
.list_slts li:hover{background:#01ab6c;color:#fff}
.wb_txt{min-height:340px}
.area_text{min-height:120px;width:640px;position:relative}
.area_text1{border:none}
.upload-videos-wrap{position:absolute;top:29px;left:45px;width:94px;height:22px}
.icon-img,.icon-music,.icon-video{background:url(/static/imgs/icon_mp4.png) 0 0 no-repeat;width:22px;height:22px;background-size:100%;display:inline-block;margin-right:3px;box-sizing:border-box;border:1px solid #fafafa}
.icon-img{background:url(/static/imgs/icon_img.png) 0 0 no-repeat}
.icon-music{background:url(/static/imgs/icon_mp3.png) 0 0 no-repeat}
.icon-img:hover,.icon-music:hover,.icon-video:hover{background-color:#fff5d4;border:1px solid #dcac6c}
.area_text{border:0;min-height:292px;width:652px}
.img_bg{position:absolute;top:0;right:-30px;width:14px;height:16px;background:url(/static/imgs/icon_delete_gray.png) 0 0 no-repeat;background-size:100%}
.area_text textarea{width:640px;height:120px;resize:none;box-sizing:border-box;padding:13px 17px;font-size:14px;border:0;background:#f5f5f5}
.from_switch{display:flex;align-items:center;height:40px;width:40px}
.addchangewrap{position:absolute;bottom:15px;left:5px}
.new_add{color:#1890ff;font-size:14px;position:absolute;right:235px;top:0;cursor:pointer}
.new_add i{font-weight:400;font-size:16px;color:#1890ff}
.bkxq_tit,.lesson_tit{display:flex;justify-content:center;position:relative}
.tits{width:111px;height:40px;background:#e6e6e6;border-radius:20px;line-height:40px;text-align:center;position:relative}
.tits:before{position:absolute;content:"";top:50%;left:-298px;width:278px;height:1px;background:#eee}
.tits:after{position:absolute;content:"";top:50%;right:-298px;width:278px;height:1px;background:#eee}
.lesson_add{border:none;position:relative}
.preservaation{color:#fff;font-size:14px;position:fixed;bottom:0;width:100%;z-index:1000;width:calc(100% - 240px)}
.preservaation-li{text-align:center;width:100%;height:100%;border-top:1px solid #efefef;background:#fff;padding:10px}
.btn{display:inline-block;width:110px;height:36px;border-radius:4px;cursor:pointer;background:#c30d23;text-align:center;line-height:36px}
.brn-back{background:#fff;border:1px solid #bfbfbf;color:#333;margin-left:10px}
.preservaation-fixed{width:100%;position:fixed;bottom:0;z-index:999999;margin-bottom:0;height:50px;line-height:50px}
.per_warning{border:1px solid #dc143c}
.per_error{border:1px solid #dc143c}
.per_success{border:1px solid #00ff7f}
.upload-list{width:585px;border:none;margin:0 auto}
.imgSrc{display:inline-block;vertical-align:middle;margin-right:12px}
.auto_audio{opacity:0;position:absolute;top:10px;left:0;width:20px;height:20px;z-index:-1;display:none}
.addnew_wrap{height:40px}
.newadd{height:38px;margin-bottom:30px;color:#01ab6c;border:none;line-height:38px}
.from-wrap-newadd{margin-top:0}
.newitem{width:110px;height:38px}
.upload-list-li{position:relative;margin-top:5px;line-height:40px;width:585px}
.music_play_icon{cursor:pointer;position:absolute;top:10px;right:0;width:20px;height:20px;background:url(/static/imgs/icon_music.png) 0 0 no-repeat}
.music{cursor:pointer;width:20px;height:20px;background:url(/static/imgs/icon_music.png) 0 0 no-repeat;margin-right:7px}
.music_play_icon_7{background:url(/static/imgs/musicicon.png) 0 0 no-repeat;background-size:contain}
.music_play_icon_8{background:url(/static/imgs/musicicon_blue.png) 0 0 no-repeat;background-size:contain}
.upload-list-li:hover{background-color:#f5f7fa}
.upload-list-li-name{position:relative;margin-right:40px;display:block}
.fa-file-text-o{margin-right:7px}
.upload-list-li-label{margin-right:11px;font-size:16px}
.upload-list-li:hover .upload-list-li-label{color:#01ab6c;font-weight:700}
.file-box{position:absolute;top:0;left:20px;border-radius:3px;color:#999;display:inline-block;line-height:40px}
.file-btn,.files-btn,.files1-btn{width:100%;height:100%;outline:0;position:absolute;top:0;left:-5%;background-color:transparent;-moz-opacity:0;-khtml-opacity:0;opacity:0;cursor:pointer}
.changebox,.iphone_img_show_style{width:230px}
.lesson_wrap{padding-top:30px}
.vue-oss-uploader-wrap{position:fixed;top:50%;left:50%;transform:translateX(-50%) translateY(-50%);width:100%;height:100%;background:rgba(0,0,0,.5)}
.videoInput{width:70px;height:30px;opacity:0;position:absolute;top:31px;left:7px;cursor:pointer;z-index:-1}
.video-top-head{width:580px;margin:10px auto 0;height:32px;background:#f4f4f4;font-size:14px;color:#333}
.video-sele{text-align:center;line-height:32px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;position:relative}
.video-sele-z{width:90px;text-align:center;line-height:32px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin:0 5px}
.mark{width:14px;height:14px;line-height:14px;color:#01ab6c;position:absolute;top:10px;left:50px;z-index:999;display:none}
.checkedbox{width:16px;height:16px;border:1px solid #d3d5d9;display:inline-block;vertical-align:middle}
.oss-video{border:1px solid #f4f4f4;border-top:0;width:580px;margin:0 auto;box-sizing:border-box;cursor:pointer;position:relative}
.image-show{width:180px;height:136px;cursor:pointer;margin-bottom:20px;margin-left:10px;margin-top:3px;position:relative;display:flex;justify-content:center;align-items:center;box-shadow:rgba(18,109,154,.4) 0 0 4px 1px}
.image-show img{max-width:180px;max-height:136px}
.image-show .mark{width:180px;height:136px;background:rgba(0,0,0,.2);font-size:40px;position:absolute;font-weight:700;top:0;left:0;color:#fff;line-height:136px;text-align:center}
.zcir{animation:go 1.5s infinite;animation-fill-mode:both}
@keyframes go{0%{transform:rotateZ(0)}
100%{transform:rotateZ(360deg)}
}
.videoBtn_wrap{position:absolute;bottom:20px;right:20px;height:32px;width:132px}
.mark_btns{position:absolute;top:0;left:0;width:132px;height:32px;box-sizing:border-box;padding-top:5px;text-align:center;background:rgba(197,197,197,.9);cursor:not-allowed}
.oss-loading-mark{position:absolute;top:0;left:0;background:0 0;width:100%;height:100%;cursor:not-allowed}
.loading_bar{position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(255,255,255,.6);display:none}
.progress_bar_load{line-height:32px;position:relative}
.progress_bar_div{border:none;line-height:32px;background:#01ab6c;height:32px}
.loading_upload_mark{position:absolute;top:0;left:0;background:0 0;width:100%;height:100%;cursor:not-allowed}
.photoviewer-header .photoviewer-button{height:30px}
.photoviewer-button{display:inline-block;width:26px;height:26px;-webkit-box-sizing:border-box;box-sizing:border-box;margin:0;font-size:16px;color:#3d3d3d;line-height:1;text-align:center;background:0 0;border-width:0;border-radius:0;cursor:pointer;outline:0}
.photoviewer-button svg{display:inline-block;font-size:inherit;width:1em;height:1em;overflow:visible;vertical-align:-.125em}
.alertBox_small{position:fixed;bottom:0;right:0;width:250px;height:55px;background:#fff;border:1px solid #e6e6e6;z-index:9999;border-radius:10px}
.alertBox_big{position:fixed;bottom:0;right:0;width:802px;height:432px;background:#fff;border:1px solid #e6e6e6;z-index:9999;border-radius:0 0 10px 10px}
.alertBox_big_pad{width:903px;height:633px}
.small_context{margin:10px auto 0}
.alertBox{z-index:1990;padding-top:4%}
.alert_context{width:800px;height:430px;margin:0 auto;background:#f5f6f6;border-radius:10px}
.alert_pad{width:900px;height:631px}
#iframe-wrap{height:100%;overflow:visible;position:relative;top:54px;z-index:50}
.mobile-width-3{height:385px!important;margin:0 auto;padding:43px 88px 27px 82px;width:774px;margin-top:15px;background:url(/static/imgs/bgiphonew.png) no-repeat;transition:all .5s ease 0s}
.mobile-width-4{height:570px!important;margin:0 auto;padding:27px 64px 27px 49px;width:880px;margin-top:15px;background:url(/static/imgs/bgpad.png) no-repeat;transition:all .5s ease 0s;background-size:contain}
.mold_left{left:0;right:0;width:160px;height:100%}
.template_7{background:#bb9450}
.template_7{background:rgba(176,100,99,.9)}
.template_8{background:rgba(176,100,99,.9)}
.mold_left_title{height:calc(100% - 32px);box-sizing:border-box;overflow-y:auto;overflow-x:hidden;width:100%}
.mold_title{height:32px;line-height:32px;box-sizing:border-box;width:100%;text-align:center;border-bottom:1px solid rgba(255,255,255,.7);color:#fff;height:42px;line-height:42px;overflow:hidden;display:flex;align-items:center}
.mold_title>span:nth-child(2){line-height:14px;text-overflow:-o-ellipsis-lastline;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:3;line-clamp:3;-webkit-box-orient:vertical}
.template_8_active{color:#ffc957}
.template_7_active{color:#ffc957}
.total_minute{box-sizing:border-box;text-align:center;color:#fff;height:32px;line-height:32px;bottom:0;width:100%}
.icon_img_src{margin-left:6px;height:100%;margin-right:6px}
.icon_img_src>img{width:16px;height:16px;vertical-align:middle}
.mobile_right_content{width:calc(100% - 160px);height:100%;box-sizing:border-box;overflow-x:hidden;background-color:#f7f8fa;overflow:hidden;position:absolute;top:0;left:160px}
.startBox{width:100%;background:rgba(230,175,169,.95);height:100%;overflow:auto;box-sizing:border-box}
.maojiorBox{overflow-x:hidden;overflow-y:auto;box-sizing:border-box}
.xunListB{padding:0 12px;box-sizing:border-box}
.momoTop{line-height:20px;width:100%;overflow-y:hidden;padding:12px 0;box-sizing:border-box;color:#fff}
.tn_con{font-size:14px!important;color:#fff;box-sizing:border-box}
.bkxq_wrapper{width:100px;height:30px;line-height:30px;padding:0 10px;text-align:center;color:#f095b9;border-radius:4px;border:1px solid #f095b9;background:#fff;margin-top:8px;cursor:pointer}
.bkxq_wrapper_blue{height:20px;text-align:center;color:#5ea5f5;background:#fff;cursor:pointer;padding-right:15px;background:url(/static/imgs/go_back_blue.png) center right no-repeat;background-size:7px}
.xq_box{width:100%;height:100%;background:rgba(230,175,169,.95) url(/static/imgs/startback.png) 0 0/100% no-repeat;background-attachment:scroll;right:0;top:0;z-index:1000;box-sizing:border-box;overflow-y:auto;display:none}
.teplate_tit{background:rgba(230,175,169,.95);height:100%;padding:0 12px;overflow:auto}
.mode_one_title{padding-right:7px;line-height:20px}
.xq_del{width:12px;height:12px;background:url(/static/imgs/xdel.png) center center no-repeat;background-size:100%;position:absolute;top:12px;right:15px;z-index:10}
.col-3{position:fixed;top:0;background:#fff;width:370px;height:500px}
.miuse_wrap{width:100%;box-sizing:border-box;padding-left:32px;padding-top:30px;height:162px;background:#fff}
.miuse_tit{margin:0 5px;overflow:hidden;line-height:1.2;padding:13px 10px;width:142px;height:43px;border-radius:8px;box-sizing:border-box;white-space:nowrap;text-overflow:ellipsis;margin-bottom:20px;text-align:center;cursor:pointer;position:relative}
.miuse_tep{width:142px;height:43px;margin-bottom:8px;box-sizing:border-box;border:1px solid #ffbe70;border-radius:8px;color:#ffbe70;line-height:43px;text-align:center;margin-left:5px;cursor:pointer;position:relative}

</style>


// WEBPACK FOOTER //
// src/components/index/makFrom/startFrom.vue